import styled from "@emotion/styled";
import { Container } from "@mui/material";

export const StyledProductDetailsBreadCrumbsSectionContainer = styled(Container)(({ theme }) => ({
  padding: "2rem 0rem !important",
  // paddingInline: 0,
}));
